import React, { Component } from 'react';
import {Col, Modal} from "react-bootstrap";
import {API} from "aws-amplify";
// import GoogleAd from "../Marketing/GoogleAd";
import {convertDate} from '../../functions/convertDate';
import {convertTime} from '../../functions/convertTime';
const Exam = props => (
  <div>
    <h4 className="exam-name" style={{paddingBottom:7, fontWeight:"bold"}}>AWS {props.examName} Practice Exam</h4>
    <img
      src={`/exam-${props.examDetail.examId}.jpg`}
      alt={`AWS ${props.examName} Practice Exam`}
    />
    <div>
      <div><b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> Created:</b> {convertDate(Number(props.examDetail.created))}</div>
      {convertDate(Number(props.examDetail.created)) !== convertDate(Number(props.examDetail.updated)) && <div>
        <b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> Updated:</b> {convertDate(Number(props.examDetail.updated))}
      </div>}
      <div><b><i className="fa fa-hashtag fa-fw" aria-hidden="true"/> Total Questions:</b> {props.examDetail.totalQuestions}</div>
      <div><b><i className="fa fa-clock-o fa-fw" aria-hidden="true"/> Time Limit:</b> {convertTime(props.examDetail.timeLimit)}</div>
      {!props.examDetail.purchased && <div>
        <b><i className="fa fa-money fa-fw" aria-hidden="true"/> Price:</b> {props.examDetail.price} credits
      </div>}
      {props.examDetail.purchased && <div>
        <b style={{color:"#5cb85c"}}><i className="fa fa-check fa-fw" aria-hidden="true"/> Purchased</b>
      </div>}
    </div>
  </div>
);
export default class ExamList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bsClass: 'modal-header modal-header-danger',
      modalTitle: 'Error',
      modalMessage: 'There aren\'t any exams available.',
      showModal: false,
      examList: []
    }
  }
  async componentDidMount(){
    try {
      const examList = await API.get("api", '/exam/list/exams');
      this.setState({examList});
    } catch(e) {
      let errorMessage = 'There aren\'t any exams available.';
      if (e.message) {errorMessage = e.message;}
      if (e.response) {errorMessage = e.response.data.errorMessage;}
      this.setState({
        bsClass: 'modal-header modal-header-danger',
        modalTitle: 'Error',
        modalMessage: errorMessage,
        showModal: true
      });
    }
  }
  modalClose = () => {
    this.setState({ showModal: false });
  };
  renderExams() {
    return this.state.examList.map(examDetail => {
      let examName;
      if (examDetail.examId === 'aws-certified-cloud-practitioner') {examName = 'Cloud Practitioner'}
      if (examDetail.examId === 'aws-certified-solutions-architect-associate') {examName = 'Solutions Architect - Associate'}
      if (examDetail.examId === 'aws-certified-developer-associate') {examName = 'Developer - Associate'}
      if (examDetail.examId === 'aws-certified-sysops-administrator-associate') {examName = 'SysOps Administrator - Associate'}
      if (examDetail.examId === 'aws-certified-solutions-architect-professional') {examName = 'Solutions Architect - Professional'}
      if (examDetail.examId === 'aws-certified-devops-engineer-professional') {examName = 'DevOps Engineer - Professional'}
      if (examDetail.examId === 'aws-certified-advanced-networking-specialty') {examName = 'Advanced Networking - Specialty'}
      if (examDetail.examId === 'aws-certified-security-specialty') {examName = 'Security - Specialty'}
      if (examDetail.examId === 'aws-certified-data-analytics-specialty') {examName = 'Data Analytics - Specialty'}
      if (examDetail.examId === 'aws-certified-machine-learning-specialty') {examName = 'Machine Learning - Specialty'}
      if (examDetail.examId === 'aws-certified-database-specialty') {examName = 'Database - Specialty'}

      // replace this return with the commented out code below to show ads between exams
      return (
        <Col
          className='blog'
          key={examDetail.examId}
          xs={12}
          onClick={() => this.props.history.push(`/exam/${examDetail.examId}`)}
        >
          <Exam examDetail={examDetail} examName={examName}/>
        </Col>
      )

      /*return (
        <div key={i}>
           Render these components because they're before an ad
          {(i === 0 || i === 3 || i === 5) && <Col
              className='blog'
              style={{marginBottom:15}}
              xs={12}
              onClick={() => this.props.history.push(`/exam/${examDetail.examId}`)}
          >
            <Exam examDetail={examDetail} examName={examName}/>
          </Col>}
           Render ads at these intervals
          {(i === 1 || i === 4 || i === 6) && <Col xs={12}><GoogleAd/></Col>}
           Render these components because they're after an ad
          {(i === 1 || i === 4 || i === 6) && <Col
            className='blog'
            style={{marginTop:15, clear:'both'}}
            xs={12}
            onClick={() => this.props.history.push(`/exam/${examDetail.examId}`)}
          >
            <Exam examDetail={examDetail} examName={examName}/>
          </Col>}
           Render these components because they're not before or after an ad
          {(i !== 0 && i !== 1 && i !== 3 && i !== 4 && i !== 5 && i !== 6) && <Col
            className='blog'
            xs={12}
            onClick={() => this.props.history.push(`/exam/${examDetail.examId}`)}
          >
            <Exam examDetail={examDetail} examName={examName}/>
          </Col>}
        </div>
      )*/


    });
  }
  render() {
    return (
      <div>
        {this.renderExams()}
        <Modal show={this.state.showModal} onHide={this.modalClose}>
          <Modal.Header bsClass={this.state.bsClass} closeButton>
            <i className="fa fa-warning fa-fw" aria-hidden="true"/> {this.state.modalTitle}
          </Modal.Header>
          <Modal.Body>
            <p>{this.state.modalMessage}</p>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Exam/ExamList.js